<template>
    <router-view>
    </router-view>
</template>


<script>
export default {
    name: 'DashboardRedirectContainer',
    props: {},
    components: {},

    data() {
        return {};
    },

    mounted() {
        this.redirect();
    },

    methods: {
        redirect() {
            //console.log('redirect dashboard')
            if (this.userInfo && this.userTypeId !== 1) {
                if (this.userTypeId == 2) {
                    this.$router.push({ name: 'MyHourlist' });
                }
                else {
                    console.warn('Partners not allowed on dashboard')
                    this.$router.push({ name: "JobList", params: { filter: "my" } });
                }
            }
            else if (this.$route.name === 'Dashboard') {
                this.$router.push({ name: 'DashboardHome' });
            }
        },
    },

    computed: {
        userTypeId() {
            return this.userInfo?.UserTypeId;
        }
    },

    watch: {
        "$route.name"() {
            this.redirect();
        },
        userTypeId() {
            this.redirect();
        },
    },
};
</script>


<style lang='scss' scoped></style>